module.exports = __webpack_public_path__ + "img/city_05.27001c7e.png";